export const htmlDefaultSource = `<!DOCTYPE html>
<html>
<head>
  <title>HTML Modernization Example</title>
</head>
<body>
  <!-- Old HTML4 structure with deprecated tags -->
  <center>This text is centered</center>
  
  <font size="4" color="blue">This text is styled with font tag</font>
  
  <div align="right">Right-aligned with align attribute</div>
  
  <table width="100%" border="1" cellspacing="0" cellpadding="5">
    <tr>
      <td bgcolor="#f0f0f0">Table cell with bgcolor</td>
    </tr>
  </table>
  
  <!-- Deprecated frame elements -->
  <frameset cols="25%,75%">
    <frame src="menu.html">
    <frame src="content.html">
  </frameset>
  
  <!-- Already modern HTML5 elements -->
  <main>
    <article>
      <header>
        <h1>This is modern HTML5</h1>
      </header>
      <section>
        <p>This section uses proper HTML5 elements</p>
      </section>
    </article>
  </main>
</body>
</html>`;

export const htmlDefaultCodemod = `import { type SgRoot } from "@ast-grep/napi";

async function transform(root: SgRoot): Promise<string | null> {
  const rootNode = root.root();

  // Replace <center> tags with styled div
  const centerNodes = rootNode.findAll({
    rule: {
      pattern: "<center>$CONTENT</center>"
    }
  });

  let edits = centerNodes.map(node => {
    const content = node.getMatch("CONTENT").text();
    return node.replace(\`<div style="text-align: center">\${content}</div>\`);
  });

  // Replace <font> tags with styled span
  const fontNodes = rootNode.findAll({
    rule: {
      pattern: "<font $ATTRS>$CONTENT</font>"
    }
  });

  edits = [
    ...edits,
    ...fontNodes.map(node => {
      const content = node.getMatch("CONTENT").text();
      const attrs = node.getMatch("ATTRS").text();
      
      // Convert color and size attributes to inline CSS
      let style = "";
      if (attrs.includes('color="')) {
        const colorMatch = attrs.match(/color="([^"]*)"/);
        if (colorMatch) {
          style += \`color: \${colorMatch[1]}; \`;
        }
      }
      if (attrs.includes('size="')) {
        const sizeMatch = attrs.match(/size="([^"]*)"/);
        if (sizeMatch) {
          const fontSize = parseInt(sizeMatch[1]) * 4 + 8;
          style += \`font-size: \${fontSize}px; \`;
        }
      }
      
      return node.replace(\`<span style="\${style.trim()}">\${content}</span>\`);
    })
  ];

  // Apply all the changes
  const newSource = rootNode.commitEdits(edits);
  return newSource;
}

export default transform;
`;

export const htmlDefaultConfig = `
# Modernize HTML4 to HTML5
id: migrate-center-tags
language: html
rule:
  pattern: "<center>$CONTENT</center>"
fix: "<div style=\\"text-align: center\\">$CONTENT</div>"
---
id: migrate-font-tags
language: html
rule:
  pattern: "<font color=\\"$COLOR\\">$CONTENT</font>"
fix: "<span style=\\"color: $COLOR\\">$CONTENT</span>"
---
id: migrate-frameset-tags
language: html
rule:
  pattern: "<frameset $$$>$$$CONTENT</frameset>"
fix: "<div class=\\"frameset-container\\">\\n  $$$CONTENT</div>"
---
id: migrate-align-attribute
language: html
rule:
  pattern: "<$T align=\\"$ALIGN\\">"
fix: "<$T style=\\"text-align: $ALIGN\\">"
`.trim();
